module.exports = __webpack_public_path__ + "img/index03.0e78682c.png";